import React from 'react';
import SvgIcon from '@material-ui/core/SvgIcon';

export default  function PopOut(props:any) {
   
    return (

        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M13.7778 4V5.77778H16.9689L8.23111 14.5156L9.48444 15.7689L18.2222 7.03111V10.2222H20V4H13.7778ZM18.2222 18.2222H5.77778V5.77778H12V4H5.77778C4.79111 4 4 4.8 4 5.77778V18.2222C4 18.6937 4.1873 19.1459 4.5207 19.4793C4.8541 19.8127 5.30628 20 5.77778 20H18.2222C18.6937 20 19.1459 19.8127 19.4793 19.4793C19.8127 19.1459 20 18.6937 20 18.2222V12H18.2222V18.2222Z" fill="currentColor"/>
        </svg>
        
    )
}